import { SET_KIOSK_SYNC_CART } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const setKioskCart = cart => ({
  type: SET_KIOSK_SYNC_CART,
  payload: cart,
});
